module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion mt-3"
  }, [_c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.accordions), function(slide, i) {
    return _c('div', {
      key: i,
      staticClass: "tab",
      style: (i != 0 ? 'margin-top: -1px' : '')
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": ("chck" + i)
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "tab-label",
      attrs: {
        "for": ("chck" + i)
      }
    }, [(_vm.leftIcon) ? _c('v-icon', {
      staticClass: "_icon_before",
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.leftIcon))]) : _vm._e(), _vm._v("\n        " + _vm._s(slide.title) + "\n      "), (_vm.rightIcon) ? _c('v-icon', {
      staticClass: "_icon_after",
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.rightIcon))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "tab-content",
      domProps: {
        "innerHTML": _vm._s(slide.content)
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6538a8e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordion.vue
// module id = 1832
// module chunks = 180